import {
    buildRecordLifecyclePagedListActions,
    type RecordLifecycleConfirmKind,
} from "../../utils/navigation/recordLifecycleActions";
import { EntityLabels } from "../../utils/navigation/pageTitles";
import type { ICustomerListRow } from "../../customTypings/customer/Customer";

export type CustomerAdminConfirmKind = RecordLifecycleConfirmKind;

export function formatCustomerToastLabel(name: string | undefined): string {
    const t = typeof name === "string" ? name.trim() : "";
    return t.length > 0 ? t : EntityLabels.customer;
}

export function getCustomerAdminActionSuccessMessage(
    kind: CustomerAdminConfirmKind,
    name: string | undefined
): string {
    const label = formatCustomerToastLabel(name);
    const successByKind: Record<CustomerAdminConfirmKind, string> = {
        disable: `${label} disabled successfully!`,
        enable: `${label} enabled successfully!`,
        softDelete: `${label} deleted successfully!`,
        restore: `${label} restored successfully!`,
    };
    return successByKind[kind];
}

export const buildCustomerAdminPagedListActions = buildRecordLifecyclePagedListActions<ICustomerListRow>;

export function canMutateCustomers(roleNames: string[]): boolean {
    const allowed = new Set([
        "System Administrator",
        "Administrator",
        "Office Staff",
        "Yard Staff",
    ]);
    return roleNames.some((r) => allowed.has(r));
}
